/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpectPackage } from '../models/ExpectPackage';
import type { Item } from '../models/Item';
import type { Package } from '../models/Package';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PackageService {
    /**
     * Create a new package
     * @param requestBody
     * @returns Package Package created successfully
     * @throws ApiError
     */
    public static postPackage(
        requestBody?: Record<string, any>,
    ): CancelablePromise<Package> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/package',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get all packages
     * @param search Search term to filter packages by description or user email
     * @param page Page number for pagination
     * @param limit Number of packages per page
     * @param startDate Filter packages created from this date
     * @param endDate Filter packages created until this date
     * @param isDraft Filter packages by draft status (true/false)
     * @param isShipped Filter packages by shipment status (true/false)
     * @param isCombined Filter packages that are part of a combined package (true/false)
     * @param userId Filter packages by user ID (admin only)
     * @returns any Paginated list of packages
     * @throws ApiError
     */
    public static getPackage(
        search?: string,
        page: number = 1,
        limit: number = 10,
        startDate?: string,
        endDate?: string,
        isDraft?: boolean,
        isShipped?: boolean,
        isCombined?: boolean,
        userId?: string,
    ): CancelablePromise<{
        data?: Array<Package>;
        pagination?: {
            total?: number;
            page?: number;
            limit?: number;
            pages?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/package',
            query: {
                'search': search,
                'page': page,
                'limit': limit,
                'startDate': startDate,
                'endDate': endDate,
                'isDraft': isDraft,
                'isShipped': isShipped,
                'isCombined': isCombined,
                'userId': userId,
            },
            errors: {
                400: `Bad Request - Invalid parameters or missing required user information`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get package by ID
     * @param id ID of the package to retrieve
     * @returns Package Package details
     * @throws ApiError
     */
    public static getPackage1(
        id: number,
    ): CancelablePromise<Package> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/package/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Package not found or access denied`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update package by ID
     * @param id
     * @param requestBody
     * @returns Package Package updated successfully
     * @throws ApiError
     */
    public static putPackage(
        id: number,
        requestBody?: {
            /**
             * Package category
             */
            category?: string;
            /**
             * Package subcategory
             */
            sub_category?: string;
            /**
             * Whether the package is a draft
             */
            isDraft?: boolean;
            /**
             * Base64 encoded image data or image URL
             */
            image?: string;
            /**
             * Base64 encoded invoice image or URL
             */
            invoice_image?: string;
            /**
             * Package name
             */
            name?: string;
            /**
             * Custom value of the package
             */
            custom_value?: string;
            /**
             * Description of the package
             */
            description?: string;
            /**
             * Shipping cost in USD
             */
            shipping_cost?: number;
            /**
             * Weight of the package in kg
             */
            weight?: number;
            /**
             * Length of the package in cm
             */
            length?: number;
            /**
             * Width of the package in cm
             */
            width?: number;
            /**
             * Height of the package in cm
             */
            height?: number;
            /**
             * Quantity of packages
             */
            quantity?: number;
            /**
             * User notes for the package
             */
            note?: string;
            /**
             * Items contained in the package
             */
            items?: Array<Item>;
            /**
             * IDs of items to be removed from the package
             */
            removedItems?: Array<number>;
        },
    ): CancelablePromise<Package> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/package/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Invalid parameters or validation errors`,
                404: `Package not found or user not authorized to update it`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete package by ID
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deletePackage(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/package/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Package not found or user not authorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload invoice for package by ID
     * @param id
     * @param requestBody
     * @returns Package Invoice uploaded successfully
     * @throws ApiError
     */
    public static postPackageUploadInvoice(
        id: number,
        requestBody: {
            /**
             * Base64 encoded image data or URL to invoice image
             */
            invoiceImage: string;
            /**
             * The ID of the user who owns the package (required for user access verification)
             */
            userId?: string;
        },
    ): CancelablePromise<Package> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/package/{id}/upload-invoice',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Invalid user type, missing user ID, or invoice image required`,
                404: `Package not found or user not authorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new expect package
     * Allows users to submit an expect package request with an invoice image
     * @param requestBody
     * @returns any Expect package created successfully
     * @throws ApiError
     */
    public static postPackageExpect(
        requestBody: any,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: ExpectPackage;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/package/expect',
            body: requestBody,
            errors: {
                400: `Missing required fields`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all expect packages
     * Get a paginated list of all expect packages. For admin users, returns all packages; for regular users, returns only their own packages.
     * @param isReceived Filter expect packages by received status
     * @param page Page number for pagination
     * @param limit Number of records to return per page
     * @returns any Paginated list of expect packages
     * @throws ApiError
     */
    public static getPackageExpect(
        isReceived?: boolean,
        page: number = 1,
        limit: number = 10,
    ): CancelablePromise<{
        data?: Array<ExpectPackage>;
        pagination?: {
            total?: number;
            page?: number;
            limit?: number;
            pages?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/package/expect',
            query: {
                'isReceived': isReceived,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
}
